module.exports = __webpack_public_path__ + "img/pay.053ad219.png";